import type { StatusVariant } from '../components/ui/StatusBadge';

// Ola 4 (D6): UNA fuente de verdad para estado→(color semántico, etiqueta de mostrador).
// Regla: un mismo concepto se ve igual en toda la app — pendiente=ámbar, confirmado=verde,
// terminal sin acción (anulado/cancelado/borrador)=neutral, requiere atención=rojo, informativo=azul.
// El enum interno se conserva; el usuario nunca ve PENDING_APPROVAL ni códigos técnicos.

export interface StatusBadgeView { variant: StatusVariant; label: string }

export function purchaseStatusBadge(status: string): StatusBadgeView {
  switch (status) {
    case 'DRAFT': return { variant: 'neutral', label: 'Borrador' };
    case 'PENDING_APPROVAL': return { variant: 'warning', label: 'Pendiente de aprobación' };
    case 'CONFIRMED': return { variant: 'success', label: 'Confirmada' };
    case 'CANCELLED': return { variant: 'neutral', label: 'Cancelada' };
    default: return { variant: 'neutral', label: status };
  }
}

export function expenseStatusBadge(status: string): StatusBadgeView {
  switch (status) {
    case 'DRAFT': return { variant: 'neutral', label: 'Borrador' };
    case 'CONFIRMED': return { variant: 'success', label: 'Confirmado' };
    case 'CANCELLED': return { variant: 'neutral', label: 'Anulado' };
    default: return { variant: 'neutral', label: status };
  }
}

export function shiftCloseStatusBadge(status: string): StatusBadgeView {
  return status === 'CLOSED'
    ? { variant: 'success', label: 'Corte cerrado' }
    : { variant: 'neutral', label: 'Corte anulado' };
}

/** Diferencia de efectivo del corte: faltante SÍ pide atención (antes se veía gris, como si nada). */
export function differenceStatusBadge(status: 'MATCHED' | 'OVER' | 'SHORT' | 'UNKNOWN'): StatusBadgeView {
  switch (status) {
    case 'MATCHED': return { variant: 'success', label: 'Sin diferencia' };
    case 'OVER': return { variant: 'warning', label: 'Sobrante' };
    case 'SHORT': return { variant: 'danger', label: 'Faltante' };
    default: return { variant: 'neutral', label: 'No calculable' };
  }
}
